<script lang="ts">
  import NauiCheckbox from "../../lib/naui/atoms/NauiCheckbox.svelte";
  import { onMount } from "svelte";
  import NauiSelect from "../../lib/naui/atoms/NauiSelect.svelte";
  import NauiDatePicker from "../../lib/naui/atoms/NauiDatePicker.svelte";
  import NauiInput from "../../lib/naui/atoms/NauiInput.svelte";
  import NauiButton from "../../lib/naui/atoms/NauiButton.svelte";
  import Dialog, { Actions, Content, Title } from "@smui/dialog";
  import NauiTextarea from "../../lib/naui/atoms/NauiTextarea.svelte";
  import { createEventDispatcher } from "svelte";
  import AuditoriaItemAuditarDefecto from "./AuditoriaItemAuditarDefecto.svelte";
  import AuditoriaItemAuditarTipoSegunda from "./AuditoriaItemAuditarTipoSegunda.svelte";
  import { scrimClickAction } from "@smui/dialog/src/Dialog.svelte";
  import Tabs from "../../lib/utils/Tabs.svelte";
  import Proveedor from "./tabs/Proveedor.svelte";
  import Tallas from "./tabs/Tallas.svelte";
  import Confeccion from "./tabs/Confeccion.svelte";
  import Medidas from "./tabs/Medidas.svelte";
  import Empaque from "./tabs/Empaque.svelte";
  import Datos from "./tabs/Datos.svelte";
  import Validacion from "./tabs/Validacion.svelte";
  import { get, writable } from "svelte/store";

  export let data;
  export let estados;
  export let subruta;
  export let is_administrador_auditoria;
  const isPaqueteCompleto = subruta === "paqueteCompleto";
  const isMaquila = subruta === "maquila";
  const dispatch = createEventDispatcher();
  let all_tamano_muestra = writable(null);
  let local_hora = writable(null);
  let hasError = writable<string[]>([])
  let defectos_cantidad_cero = [];
  let Evidencias = [];
  let EvidenciasEliminar = [];
  let tmpObs;
  let tmpEst;
  let tmpTam;
  let tmpCant;
  let tmpTipoAud;
  let viendo = true;
  let res;
  let defectos = [];
  let id_auditables = [];
  let defectos_auditables = [];
  let auditable_defecto_data = [];
  let cargaVer = false;
  let dialogOpen = false;
  let dialogOpenObs = false;
  let mensaje = "";
  let resp;
  let resD;
  let recarga = 0;
  var fdata = new FormData();
  let dialogOpen__ = false;
  let confirmCloseDialogOpen__ = false;
  
let items =[]

if(data.tipo_auditoria !== "Segundas"){
  let talla_colores_length = data.lista_talla_colores.length;
  items = [
    { label: "Datos Generales", value: 1, component: Proveedor, props: { data: data, local_hora, hasError:hasError } },
    { label: "Unidad Talla-Color", value: 2, component: Tallas, props: { data: data, count_row: talla_colores_length >=6 ? talla_colores_length : 6, hasError:hasError}},
    { label: "Auditoría Confección", value: 3, component: Confeccion, props:{data:data, all_tamano_muestra: all_tamano_muestra, hasError:hasError} },
    { label: "Auditoría Medidas", value: 4, component: Medidas, props: {data:data,  hasError:hasError}},
    { label: "Auditoría Empaque", value: 5, component: Empaque, props: {data:data ,all_tamano_muestra}},
    { label: "Datos Específicos", value: 6, component: Datos,  props: {data:data, hasError:hasError}},
    ...is_administrador_auditoria ? [{ label: "Validación", value: 7, component: Validacion, props:{data:data, estados:estados} }] : []
  ];
}

  let formData = {};

  onMount(() => {

    $all_tamano_muestra = data.tamano_muestra == null? data.muestra : data.tamano_muestra;
    Evidencias = data.evidencia;
    Evidencias = data.evidencia.map((x) => {
      return { archivo: x, nombre: x.replace(data.id + "_", ""), nuevo: false };
    });

    Evidencias = Evidencias.filter((x) => x.nombre != "");
    tmpObs = data.observacion;
    tmpEst = data.estado;
    tmpTam = data.muestra;
    tmpTipoAud = data.tipo_auditoria;
    tmpCant = data.cantidad_aud;
  });

  function ver() {
    cargaVer = !cargaVer;
    if (viendo) {
      buscar_defecto_auditables();
    }
  }

  async function buscar_defecto_auditables() {
    defectos_auditables = data.lista_defectos_auditables;
    defectos_auditables = defectos_auditables;
  }

  function onClick() {
    tmpObs = data.observacion;
    dialogOpenObs = true;
  }

  function showPopUp() {
    $local_hora = data.hora_fin_aud ? data.hora_aud:new Date().toLocaleTimeString('en-GB', { timeZone: 'America/Bogota', hour: '2-digit', minute: '2-digit' });
    dialogOpen__ = true;
  }


  function closePopUp() {
    confirmCloseDialogOpen__ = true;
  }

  function confirmClose() {
    dialogOpen__ = false;
    confirmCloseDialogOpen__ = false;
    dispatch("RefrescarItem");
  }
  function cancelConfirmClose() {
    confirmCloseDialogOpen__ = false;
  }

  function quitar(arc) {
    let E = Evidencias.filter((x) => x.archivo == arc && x.nuevo == false);
    //si el archivo no es nuevo si se adicionar para eliminar del repositorio
    if (E.length > 0) {
      const item = {
        archivo: arc,
      };
      EvidenciasEliminar.push(item);
    }
    Evidencias = Evidencias.filter((x) => x.archivo != arc);
  }

  function validar() {
    let retorno = true;
    if (tmpEst.trim() == "Cancelado") {
      return true;
    }

    if (tmpEst.trim() == "Programada") {
      mensaje =
        "No puede seleccionar el estado Programada. Por favor seleccione otro estado";
      return false;
    }

    if (tmpTipoAud === "Primeras") {
      if (tmpTam == 0 || tmpTam == null) {
        mensaje = "El tamaño de la muestra no puede ser 0";
        return false;
      }

      if (tmpCant == 0 || tmpCant == null) {
        mensaje = "La cantidad auditada no puede ser 0";
        return false;
      }
    }

    if (tmpObs.trim() == "") {
      mensaje = "Debe ingresar observaciones";
      return false;
    }

    if (tmpTipoAud === "Segundas") {
      data.cantidad_aud = data.cantidad_primeras + data.cantidad_segundas;

      const uniqueValues = new Set(
        auditable_defecto_data.map((v) => v.defecto_id)
      );
      if (uniqueValues.size < auditable_defecto_data.length) {
        mensaje = "No puedes seleccionar dos veces el mismo defecto.";
        return false;
      }

      if (
        auditable_defecto_data
          .filter((x) => x.defecto_id === 0 || x.defecto_id === null)
          .map((x) => {
            return x;
          }).length > 0
      ) {
        mensaje = "El defecto ingresado no existe.";
        return false;
      }

      defectos_cantidad_cero = auditable_defecto_data
        .filter((x) => x.cantidad === 0 || x.cantidad === null)
        .map((x) => {
          return x;
        });
      if (defectos_cantidad_cero.length > 0) {
        mensaje = "Debe asignar cantidad a los defectos.";
        return false;
      }
    }
    return retorno;
  }

  async function auditar() {
    if (!validar()) {
      dialogOpen = true;
      return false;
    }

    if (tmpTipoAud === "Primeras" || tmpTipoAud == null) {
      if (tmpTam == null || tmpTam <= 0) {
        mensaje = "El tamaño de muestra es obligatorio y debe ser mayor que 0.";
        dialogOpen = true;
        return false;
      }
    }
 
    data.estado = tmpEst;
    data.observacion = tmpObs;
    data.muestra = tmpTam;
    data.procesoAuditado = subruta;
    if (tmpTipoAud === "Segundas") {
      data.cantidad_aud = data.cantidad_primeras + data.cantidad_segundas;
    } else {
      data.cantidad_aud = tmpCant;
    }
    data.evidencia = Evidencias.map((x) => {
      return x.archivo;
    });
    dialogOpenObs = false;

    fdata.append("data", JSON.stringify(data));
    fdata.append("id", data.id);
    fdata.append("EvidenciasEliminar", JSON.stringify(EvidenciasEliminar));
    fdata.append(
      "auditable_defecto_data",
      JSON.stringify(auditable_defecto_data)
    );

    const response = await fetch("/auditoria/guardar_auditar_uno", {
      method: "post",
      body: fdata,
    });
    resp = await response.json();

    if (response.ok) {
      mensaje = resp["mensaje"];
      dialogOpen = true;
      recarga = 1;
    }
  }

  async function archivoSeleccionado(e) {
    var data = new FormData();
    for (let f of e.target.files) {
      data.append("archivo_subir", f);
    }
    data.append("id", e.target.getAttribute("data-id"));
    resp = await fetch("subir", {
      method: "POST",
      body: data,
    });
    let respuesta = await resp.json();
    if (resp.ok) {
      mensaje = respuesta["mensaje"];
      Evidencias = Evidencias.concat(respuesta["files"]);
      dialogOpen = true;
    } else {
      mensaje = respuesta["mensaje"];
      dialogOpen = true;
    }
  }

  async function archivoSeleccionado_temporal(e) {
    for (let f of e.target.files) {
      fdata.append("archivo_subir", f);
      Evidencias.push({
        nombre: f.name,
        archivo: data.id + "_" + f.name,
        nuevo: true,
      });
    }
    Evidencias = Evidencias;
  }

  //Funcion que captura los cambios en la data de los componentes y la empareja con el objeto data
  function handleTabChange(event) {
    formData = event.detail;

    let { Confeccion, Datos, Empaque, Medidas, Proveedor, Tallas, Validacion } = formData['formData'];
    
    let confeccionData = Confeccion;
    let datosData = Datos;
    let empaqueData = Empaque;
    let medidasData = Medidas;
    let proveedorData = Proveedor;
    let tallasData = Tallas;
    let validacionData = Validacion;

    let dataUnificada = {
      ...confeccionData,
      ...datosData,
      ...empaqueData,
      ...medidasData,
      ...proveedorData,
      ...tallasData,
      ...validacionData
    };

    data = {
      ...data,
      ...dataUnificada
    };
  }

  function validarAcceso() {
    return is_administrador_auditoria || ["Aprobado", "Programada"].includes(data.estado);
  }

  async function completarInformacionAuditoria(){
    //Colocar hora final de la auditoria
    if (!data.hora_fin_aud) {
      data.hora_fin_aud = new Date().toLocaleTimeString('en-GB', { timeZone: 'America/Bogota', hour: '2-digit', minute: '2-digit' });
    }

    if(!$all_tamano_muestra){
      hasError.update(errors => errors.filter(error => error !== 'Tamaño de Muestra [Campo]'));
      hasError.update(errors => [...errors, 'Tamaño de Muestra [Campo]']);
    }else{
      hasError.update(errors => errors.filter(error => error !== 'Tamaño de Muestra [Campo]'));
    }
    data.tamano_muestra = $all_tamano_muestra;
    data.hora_aud = $local_hora;
    data.fecha_aud = data.fecha;
  }


  async function validarPPP(): Promise<boolean> {
    // Helper function para validar el conjunto especificacion/unidad
    function isValid(especificacion: number | null, unidad: number | null): boolean {
      if (especificacion === null || unidad === null) {
        return false; 
      }
      const minValue = Number(especificacion) - 1;
      const maxValue = Number(especificacion) + 1; 

      return unidad >= minValue && unidad <= maxValue;
    }
    var fileteValid = true;
    var realceValid = true;
    var costuraPrendaValid = true;

    // validar el conjunto de campos necesarios
    if(data.ppp_filete_especificacion!=null && data.ppp_filete_unidad !=null){
      fileteValid = isValid(data.ppp_filete_especificacion, data.ppp_filete_unidad);
    }
    if(data.ppp_realce_especificacion!=null && data.ppp_realce_unidad !=null){
      realceValid = isValid(data.ppp_realce_especificacion, data.ppp_realce_unidad);
    }
    if(data.ppp_costura_prenda_especificacion!=null && data.ppp_costura_prenda_unidad !=null){
      costuraPrendaValid = isValid(data.ppp_costura_prenda_especificacion, data.ppp_costura_prenda_unidad);
    }

    // retorna true si todos los campos son válidos
    return fileteValid && realceValid && costuraPrendaValid;
  }

  async function AsignarEstadoPrimeras() {

    var pppEstado = await validarPPP();

    // Verificar si algún estado es `false`
    const hasRechazo = [data.confeccion_estado, data.medidas_estado, data.empaque_estado,
      data.especifico_prueba_elongacion_cuello,
      pppEstado
    ].includes(false);

      // Verificar si exactamente uno de los estados es `true` y los demás son `null`
    const hasAprobado = [data.confeccion_estado, data.medidas_estado, data.empaque_estado]
        .filter(state => state === true).length >= 1 &&
        [data.confeccion_estado, data.medidas_estado, data.empaque_estado]
        .filter(state => state === null).length <3;

    // Asignar estado según las condiciones y si no es administrador
    // Cuando es administrador/corrdinador de auditoria, el estado se asigna en la ventana de `Validación`
    if (!is_administrador_auditoria) {
        if (hasRechazo) {
            data.estado = "Rechazo Por Confirmar";
        } else if (hasAprobado) {
            data.estado = "Aprobado";
        }
    }
  }
  

  async function AuditarPrimeras() {

    //Validar estado de la auditoria
    if(data.confeccion_estado == null && data.medidas_estado == null && data.empaque_estado == null){
      mensaje = `Se debe definir un estado para la auditoria en algúna de las ventanas:
      <ul><li>Auditoría Confección</li> <li>Auditoría Medidas</li> <li>Auditoría Empaque</li></ul>`;
      dialogOpen = true;
      return false;
    }
    await AsignarEstadoPrimeras();
    
    await completarInformacionAuditoria();

    if ($hasError.length > 0) {
      mensaje = `Debe completar la información en:<br><ul>` + $hasError.map(error => `<li>${error}</li>`).join('') + `</ul>`;
      dialogOpen = true;
      return false;
    }

    data.evidencias = data.evidencias.map(e => e.archivo).join(',');
    fdata.append("data", JSON.stringify(data));
    fdata.append("id", data.id);
    fdata.append("EvidenciasEliminar", JSON.stringify(data.evidenciasEliminar));
    data.archivo_subir.forEach((archivo) => {
      fdata.append("archivo_subir", archivo);
    });

    const response = await fetch("/auditoria/guardar_reporte_auditar", {
      method: "post",
      body: fdata,
    });

    resp = await response.json();
    if (response.ok) {
      mensaje = resp["mensaje"];
      dialogOpen = true;
      recarga = 1;
    }
    else{
      mensaje = "Ha ocurrido un error al guardar la auditoria, por favor vuelva a intentarlo";
      dialogOpen = true;
      return false;
    }
  }

</script>

<tr>
  <td>
    {data.vendor}
  </td>

  {#if isPaqueteCompleto}
    <td>
      {data.po}
    </td>
  {/if}
  <td>
    {data.referencia}
  </td>
  {#if isMaquila}
    <td>
      {data.tipo_auditoria}
    </td>
    <td>
      <NauiCheckbox bind:value={data.liquidar} disabled={true} />
    </td>
  {/if}
  <td>
    {data.tamano_muestra == null? data.muestra : (data.tamano_muestra??0)}
  </td>

  <td>
    {data.tipo_empaque}
  </td>

  <td>
    {data.Q}
  </td>
  {#if isMaquila}
    <td>
      {data.orden}
    </td>
  {/if}
  {#if isMaquila}
    <td>
      <NauiCheckbox bind:value={data.critica} disabled={true} />
    </td>
  {/if}
  {#if isMaquila}
    <td>
      <NauiCheckbox bind:value={data.auditada} disabled={true} />
    </td>
  {/if}
  <td>
    {data.cantidad}
  </td>
  {#if isMaquila}
  <td>
    {data.cantidad_aud}
  </td>
    <td>
      {data.cantidad_segundas}
    </td>
  {/if}
  <td>
    {data.estado}
  </td>
  <td>
    {data.fecha_pro}
  </td>
  <td>
    {data.hora_pro}
  </td>
  <td>
    {data.auditor}
  </td>
  <td>
    {data.observacion}
  </td>
  <td>
    <NauiCheckbox bind:value={data.medida} disabled={true} />
  </td>
  <td>
    <NauiCheckbox bind:value={data.empaque} disabled={true} />
  </td>
  <td>
    <NauiCheckbox bind:value={data.confeccion} disabled={true} />
  </td>
  <td>
    <NauiButton
      caption="Auditar"
      mode="outline"
      color="accent"
      on:click={isMaquila && tmpTipoAud === "Segundas" ? onClick : showPopUp}
    />
    {#if tmpTipoAud === "Segundas" && tmpEst.trim() !== "Programada"}
      <NauiButton caption="Ver" mode="outline" color="accent" on:click={ver} />
    {/if}
  </td>
</tr>
{#if cargaVer && tmpTipoAud === "Segundas"}
  <AuditoriaItemAuditarDefecto {data} {defectos_auditables} />
{/if}

<!--Modal para la auditoria de tipo segundas-->
<Dialog bind:open={dialogOpenObs} scrimClickAction="" escapeKeyAction="">
  <Title>
    <h3 class="text-c">Auditar</h3>
  </Title>
  <Content>
    <div class="max-w-600px text-c mx-auto px-15">
      <table class="naui-table w-600">
        <tr>
          <th> Estado </th>
          <td>
            <NauiSelect bind:value={tmpEst} options={estados} label="" />
          </td>
        </tr>
        {#if tmpTipoAud === "Primeras" || tmpTipoAud == null}
          <tr>
            <th> Tamaño de muestra </th>
            <td>
              <NauiInput bind:value={tmpTam} type="number" label="" />
            </td>
          </tr>
        {/if}

        {#if tmpTipoAud === "Primeras" || tmpTipoAud == null}
          <tr id="tr-cant-aud">
            <th> Cantidad auditada </th>
            <td>
              <NauiInput bind:value={tmpCant} type="number" label="" />
            </td>
          </tr>
        {:else}
          <AuditoriaItemAuditarTipoSegunda
            bind:auditable_defecto_data
            {data}
            auditables_defectos={defectos_auditables}
            defectos_lista={defectos}
          />
        {/if}

        <tr>
          <th colspan="1"> Observaciones </th>
          <td style="text-align:left">
            <NauiTextarea bind:value={tmpObs} label="" cols="38" rows="3" />
          </td>
        </tr>
        <tr>
          <th> Evidencias </th>
          <td style="text-align:left">
            <div>
              <label class="material-icons accent" for={`image_src_${data.id}`}
                >file_present</label
              >
              <input
                type="file"
                accept=".pdf,.xls,.xlsx,.doc,.docx,.png,.jpg,.jpeg,.bmp,.rar,.zip"
                name={`image_src_${data.id}`}
                id={`image_src_${data.id}`}
                data-id={data.id}
                on:change={archivoSeleccionado_temporal}
                class="custom-input-file"
                multiple
              />
            </div>
            <table>
              {#each Evidencias as itemE}
                {#if itemE.nuevo}
                  <tr>
                    <td style="text-align:left">
                      <NauiButton
                        icon="disabled_by_default"
                        mode="outline"
                        color="accent"
                        iconStyle="outlined"
                        on:click={quitar(itemE.archivo)}
                      />
                    </td>
                    <td style="text-align:left">
                      {itemE.nombre} <br />
                    </td>
                  </tr>
                {:else}
                  <tr>
                    <td style="text-align:left">
                      <NauiButton
                        icon="disabled_by_default"
                        mode="outline"
                        color="accent"
                        iconStyle="outlined"
                        on:click={quitar(itemE.archivo)}
                      />
                    </td>
                    <td style="text-align:left">
                      <a
                        href="/auditoria/descargar?file={itemE.archivo}&nombre={itemE.nombre}"
                        target="blank"
                        >{itemE.nombre}
                      </a><br />
                    </td>
                  </tr>
                {/if}
              {/each}
            </table></td
          >
        </tr>
      </table>
    </div>
  </Content>
  <Actions>
    <div class="box-r sx-ii px-1 py-ii">
      <NauiButton
        caption="CANCELAR"
        mode="outline"
        color="accent"
        on:click={() => {
          tmpObs = data.observacion;
          tmpEst = data.estado;
          tmpTam = data.muestra;
          // tmpCant = data.cantidad_aud;

          Evidencias = data.evidencia;
          Evidencias = data.evidencia.map((x) => {
            return {
              archivo: x,
              nombre: x.replace(data.id + "_", ""),
              nuevo: false,
            };
          });
          Evidencias = Evidencias.filter((x) => x.nombre != "");

          EvidenciasEliminar = [];
          fdata = new FormData();
          document.getElementById("image_src_" + data.id).value = "";
          dialogOpenObs = false;
        }}
      />
    </div>

    <div class="box-r sx-ii px-1 py-ii">
      <NauiButton
        on:change
        caption="AUDITAR"
        mode="solid"
        color="accent"
        on:click={() => {
          auditar();
        }}
      />
    </div>
  </Actions>
</Dialog>

{#if data.tipo_auditoria !== "Segundas"}
<!-- Modal con los Tabs para el formlario de auditoria (Primeras) -->
<Dialog
  bind:open={dialogOpen__}
  fullscreen
  aria-labelledby="over-fullscreen-title"
  aria-describedby="over-fullscreen-content"
  escapeKeyAction=""
  scrimClickAction=""
  class="dialogAuditar"
>
  <Content>
    <Tabs {items} {closePopUp} on:tabChange={handleTabChange}/>
  </Content>

  <Actions>
    <div class="stepperRigth">
      <NauiButton caption="Cancelar" color="accent" mode="outline" on:click={closePopUp} />
      
      {#if validarAcceso()}
        <NauiButton caption="Guardar" mode="outline" color="accent" on:click={AuditarPrimeras} />
      {/if}
    
    </div>
  </Actions>
</Dialog>

{/if}

<Dialog
  bind:open={confirmCloseDialogOpen__}
  scrimClickAction=""
  escapeKeyAction=""
>
  <Title>
    <h3>¿Está seguro de cancelar el proceso?</h3>
  </Title>
  <Content>
    <p>Se perderán todos los datos que se hayan ingresado hasta el momento.</p>
  </Content>
  <Actions>
    <NauiButton
      caption="Cancelar"
      color="accent"
      on:click={cancelConfirmClose}
    />
    <NauiButton caption="Confirmar" color="accent" on:click={confirmClose} />
  </Actions>
</Dialog>

<Dialog bind:open={dialogOpen} scrimClickAction="" escapeKeyAction="">
  <Title>
    <h3 class="text-c">Auditar</h3>
  </Title>
  <Content>
    <div class="max-w-400px text-c mx-auto px-15">
      <p class="large">
        {@html mensaje}
      </p>
    </div>
  </Content>
  <Actions>
    <div class="box-r sx-ii px-1 py-ii">
      <NauiButton
        caption="Aceptar"
        color="accent"
        on:click={() => {
          dialogOpen = false;
          if (recarga === 1) {
            dispatch("Eauditar");
          }
          document.body.classList.remove("mdc-dialog-scroll-lock");
        }}
      />
    </div>
  </Actions>
</Dialog>

<style>
  .custom-input-file {
    display: none;
  }

  .button-style-ver {
    margin-left: 10px;
  }

  .stepperRigth {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 25px;
    margin-bottom: 20px;
    margin-right: 10 px;
  }

  @media (max-width: 1280px) {
    :global(
        .dialogAuditar.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface
      ) {
      width: 90vw;
    }
  }
</style>

